import React, { Component, Fragment } from "react";
import { Button, Col, Form, Input, FormGroup, Row } from "reactstrap";
import { Multiselect } from "multiselect-react-dropdown";
import axios from "axios";
// import { CheckBoxSelection, Inject, MultiSelectComponent } from '@syncfusion/ej2-react-dropdowns';
import FormLayout from "../FormLayout";
import { AppNavbarBrand } from "@coreui/react";
import { Checkbox, Radio } from "antd";
import disableBrowserBackButton from "disable-browser-back-navigation";
import {
  AppHeader,
  // AppBreadcrumb2 as AppBreadcrumb,
  AppSidebarNav2 as AppSidebarNav,
} from "@coreui/react";
import logo from "assets/img/brand/stepapp_logo.png";
import { connect } from "react-redux";
// import { login } from 'store/auth/actions';
// import DefaultHeader from '../../../containers/components/header';
import "./school.css";
import "./dropdown.css";

const mapDispatchToProps = (dispatch) => ({
  // login: (payload) => {
  //     dispatch(login(payload));
  // }
});

const mapStateToProps = (state) => {
  const user = state.user;
  // console.log("user in select school", user);
  return {
    isPace: false,
    role: "superadmin",
    // isSuperAdmin: user.isSuperAdmin,
    schoolChainId: user?.school?.schoolChainId,
    // schoolId: user.schoolId,
    preSelectedSchools: [],
  };
};

class SelectSchool extends Component {
  constructor(props) {
    super(props);

    this.multiselectRef = React.createRef();
    this.state = {
      selectedSchoolIndex: "",
      schools: [],
      multiSchoolIdArr: [],
      multiSchoolBoardId: "",
      multiselectFlag: false,
      selectAllFlag: false,
      clearAllFlag: false,
    };
  }

  resetValues() {
    // By calling the belowe method will reset the selected values programatically
    this.multiselectRef.current.resetSelectedValues();
  }

  updateSchool = (e) => {
    const { value } = e.target;
    this.setState({ selectedSchoolIndex: value });
  };

  componentDidMount() {
    disableBrowserBackButton();

    if (this.props.role === "superadmin") {
      this.setState({
        multiselectFlag: true,
      });
    } else {
      this.setState({
        multiselectFlag: false,
      });
    }

    this.getSchools();
  }

  getSchools = async () => {
    let selectAllFlag = localStorage.getItem("selectAllFlag");
    let schoolChainId =
      this.props.schoolChainId !== undefined ? this.props.schoolChainId : 247;
    let schools = await axios.get(
      "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/schools/list",
      {
        // schoolChainId: 247
        params: {
          schoolChainId: schoolChainId,
          // schoolChainId: 247
        },
      }
    );
    schools = schools.data;

    let schoolIdStr = this.props.schoolId;
    var schoolIdArr = [];
    if (schoolIdStr !== undefined) {
      if (schoolIdStr.length > 0) {
        schoolIdArr = schoolIdStr.split(",").map(function (item) {
          return parseInt(item, 10);
        });
      }
    }

    var result = [];
    result = schools.filter((obj) => {
      return schoolIdArr.includes(obj.id);
    });

    let selectedSchoolIdArr = [];
    let selectedSchoolNameArr = [];
    let selectedBoardId;
    result.map((t) => {
      selectedBoardId = t.board_id;
      selectedSchoolIdArr.push(t.id);
      selectedSchoolNameArr.push(t.school_name.toString().replace(/,/g, "-"));
    });

    let schoolIdstr = selectedSchoolIdArr.toString();
    let selectedSchoolNameStr = selectedSchoolNameArr.toString();

    this.setState({
      selectAllFlag: selectAllFlag === "true" ? true : false,
      schools: schools,
      preSelectedSchools: result,
      selectedSchoolIndex: result.length > 0 ? "1" : "",
      multiSchoolIdArr: schoolIdstr,
      multiSchoolNameArr: selectedSchoolNameStr,
      multiSchoolBoardId: selectedBoardId,
    });
  };

  onSelect = (e) => {
    const option = [];
    let selectedSchoolIdArr = [];
    let selectedSchoolNameArr = [];
    let selectedBoardId;

    if (e.length > 0) {
      e.forEach((select) => {
        let roleDate = {};
        roleDate.schoolName = select.school_name;
        roleDate.id = select.id;
        roleDate.board_id = select.board_id;
        option.push(roleDate);
        selectedSchoolIdArr.push(select.id);
        selectedSchoolNameArr.push(
          select.school_name.toString().replace(/,/g, "-")
        );
        selectedBoardId = select.board_id;
      });
    }

    let schoolIdstr = selectedSchoolIdArr.toString();
    let selectedSchoolNameStr = selectedSchoolNameArr.toString();
    this.setState({
      clearAllFlag: false,
      multiSchoolIdArr: schoolIdstr,
      multiSchoolNameArr: selectedSchoolNameStr,
      multiSchoolBoardId: selectedBoardId,
      selectedSchoolIndex: "1",
    });
  };

  onRemove = (e) => {
    let selectedSchoolIdArr = [];
    let selectedSchoolNameArr = [];
    let selectedBoardId;
    if (e.length > 0) {
      e.forEach((select) => {
        selectedSchoolIdArr.push(select.id);
        selectedBoardId = select.board_id;
        selectedSchoolNameArr.push(
          select.school_name.toString().replace(/,/g, "-")
        );
      });
    }

    let schoolIdstr = selectedSchoolIdArr.toString();
    let selectedSchoolNameStr = selectedSchoolNameArr.toString();

    this.setState({
      multiSchoolIdArr: schoolIdstr,
      multiSchoolBoardId: selectedBoardId,
      multiSchoolNameArr: selectedSchoolNameStr,
      selectedSchoolIndex: selectedSchoolIdArr.length > 0 ? "1" : "",
    });
  };

  onSelectAll = (e) => {
    let chkVal = e.target.checked;
    let allSchools = this.state.schools;
    let selectedBoardId;
    let selectedSchoolIdArr = [];
    let selectedSchoolNameArr = [];

    allSchools.map((t) => {
      selectedBoardId = t.board_id;
      selectedSchoolIdArr.push(t.id);
      selectedSchoolNameArr.push(t.school_name.toString().replace(/,/g, "-"));
    });
    let schoolIdstr = selectedSchoolIdArr.toString();
    let selectedSchoolNameStr = selectedSchoolNameArr.toString();

    this.setState({
      selectAllFlag: chkVal === true ? true : false,
      clearAllFlag: false,
      preSelectedSchools: chkVal === true ? this.state.schools : [],
      selectedSchoolIndex: chkVal === true ? "1" : "",
      multiSchoolIdArr: schoolIdstr,
      multiSchoolNameArr: selectedSchoolNameStr,
      multiSchoolBoardId: selectedBoardId,
    });
  };

  onClear = (e) => {
    let chkVal = e.target.checked;
    console.log(chkVal);
    this.resetValues();
    this.setState({
      selectAllFlag: false,
      clearAllFlag: chkVal === true ? true : false,
      preSelectedSchools: chkVal === true ? [] : [],
      selectedSchoolIndex: chkVal === true ? "" : "",
      multiSchoolIdArr: [],
      multiSchoolNameArr: [],
      multiSchoolBoardId: [],
    });
  };

  redirectTo = () => {
    let selectAllFlag = this.state.selectAllFlag;
    localStorage.setItem("selectAllFlag", selectAllFlag);
    let multiselectFlag = this.state.multiselectFlag;
    localStorage.setItem("multiselectFlag", multiselectFlag);
    localStorage.setItem("multiselectFlagId", this.state.multiSchoolIdArr);
    localStorage.setItem(
      "multiselectSchoolName",
      this.state.multiSchoolNameArr
    );

    if (this.state.multiselectFlag === false) {
      const selectedSchool = this.state.schools[this.state.selectedSchoolIndex];
      const payload = {
        schoolId: selectedSchool.id,
        boardId: selectedSchool.board_id,
      };
      // this.props.login(payload);
      this.props.history.push("/pace-view/dashboard");
    } else {
      const payload = {
        schoolId: this.state.multiSchoolIdArr,
        boardId: this.state.multiSchoolBoardId,
        selectedSchoolName: this.state.multiSchoolNameArr,
      };
      // this.props.login(payload);
      // this.props.history.push('/master-school-dashboard');
      this.props.history.push({
        // pathname: '/master-school-dashboard',
        pathname: "/dashboard",
        state: {
          schoolId: this.state.multiSchoolIdArr,
          boardId: this.state.multiSchoolBoardId,
          selectedSchoolName: this.state.multiSchoolNameArr,
        },
      });
    }
  };

  fields = {
    text: "school_name",
    value: "id",
  };

  OnSelected = (e) => {
    console.log(e);
  };

  render() {
    return (
      <Fragment>
        <AppHeader fixed>{/* <DefaultHeader /> */}</AppHeader>
        <br />
        <br />
        <FormLayout>
          <Form>
            <div className="row">
              <div className="col-md-12 text-center">
                {/* <AppNavbarBrand full={{ src: logo, width: 200, height: 80, alt: 'logo' }} /> */}
              </div>
              <div className="col-md-12 text-center my-2">
                {/* <h3>Select School</h3> */}
              </div>
              <div
                className="col-md-12"
                style={{
                  display: this.state.multiselectFlag === false ? "" : "none",
                }}
              >
                <FormGroup row>
                  <Input
                    type="select"
                    className="select_box"
                    name="selectedSchool"
                    value={this.state.selectedSchoolIndex}
                    onChange={this.updateSchool}
                  >
                    <option value="">Please select</option>
                    {this.state.schools.map((s, index) => (
                      <option key={s.id} value={index}>
                        {s.school_name}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </div>
              <div
                className="col-md-12"
                style={{
                  display: this.state.multiselectFlag === true ? "" : "none",
                  minHeight: "300px",
                }}
              >
                {/* <Col xs="3"></Col> */}

                <div className="my-2">
                  {/* <Checkbox onChange={this.onSelectAll}>Select All Schools</Checkbox> */}
                  {/* <Checkbox onChange={this.onSelectAll} checked={this.state.selectAllFlag === true} >Select All Schools</Checkbox>  
                               <Checkbox onChange={this.onClear} checked ={this.state.clearAllFlag === true}> Clear  </Checkbox> */}

                  <Radio
                    onChange={this.onSelectAll}
                    checked={this.state.selectAllFlag === true}
                  >
                    Select All Schools
                  </Radio>
                  <Radio
                    onChange={this.onClear}
                    checked={this.state.clearAllFlag === true}
                    disabled={!this.state.selectedSchoolIndex}
                  >
                    {" "}
                    Clear{" "}
                  </Radio>
                </div>
                <Multiselect
                  options={this.state.schools} // Options to display in the dropdown
                  showCheckbox={true}
                  showSelectAll={true}
                  closeOnSelect={false}
                  selectedValues={this.state.preSelectedSchools} // Preselected value to persist in dropdown
                  onSelect={this.onSelect} // Function will trigger on select event
                  onRemove={this.onRemove} // Function will trigger on remove event
                  displayValue="school_name" // Property name to display in the dropdown options
                  avoidHighlightFirstOption={true}
                  ref={this.multiselectRef}
                
                />

                {/* <MultiSelectComponent 
                                   id="checkbox"
                                   dataSource={this.state.schools}
                                   fields={this.fields}
                                   placeholder="Select school"
                                   mode="CheckBox"
                                   selectAllText="Select All"
                                   unSelectAllText="unSelect All"
                                   showSelectAll={true}
                                   aria-selected="true"
                                   // onClick={this.OnSelect}
                                   Select={this.OnSelected}
                               >
                                   <Inject services={[CheckBoxSelection]} />
                               </MultiSelectComponent> */}
              </div>
              <div className="col-md-12">
                <Button
                  color="primary"
                  className="px-4 w-100"
                  onClick={this.redirectTo}
                  disabled={!this.state.selectedSchoolIndex}
                >
                  Proceed
                </Button>
              </div>
            </div>
          </Form>
        </FormLayout>
      </Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectSchool);
